import HeroCarousel from "./HeroCarousel";
import PopularCategories from "./PopularCategories";
import HighlightedFeatures from "./HighlightedFeatures";
import SubscribeSection from "./SubscribeSection";
import EducationalFeatures from "./EducationalFeatures";
import MostViewedVideos from "./MostViewedVideos";
import LuckyDrawModals from "./LuckyDrawModals";
import type {
  Category,
  CoursesByCategory,
  FormError,
  MostViewedVideo,
} from "../../types/home";

export interface HomeProps {
  /** Lucky-draw popup visibility (owned by the app shell). */
  show: boolean;
  onCloseModal: () => void;

  categories: Category[];
  courses: CoursesByCategory;
  mostViewedVideos: MostViewedVideo[];

  /** Whether a subscribed user (cookie present) is viewing the page. */
  isSubscribed: boolean;
  token: string | null;
  utmSource: string;

  webOtp: string | null;
  otpStatus: boolean;
  loader: boolean;
  error: FormError;
  phNumber: string;
  onSubscribe: (phone: string) => void;
  onVerifyOtp: (otp: string) => void;
  setUserPackage: (value: string) => void;
  setLoader: (value: boolean) => void;
  setIsActive: (value: boolean) => void;

  onMostViewedClick: (video: MostViewedVideo) => void;
}

/**
 * Pure presentation layer for the Home screen: it only arranges sections and
 * forwards props. All data fetching and business logic live in `HomeScreen`.
 */
const Home = ({
  show,
  onCloseModal,
  categories,
  courses,
  mostViewedVideos,
  isSubscribed,
  token,
  utmSource,
  webOtp,
  otpStatus,
  loader,
  error,
  phNumber,
  onSubscribe,
  onVerifyOtp,
  setUserPackage,
  setLoader,
  setIsActive,
  onMostViewedClick,
}: HomeProps) => (
  <>
    <LuckyDrawModals show={show} onClose={onCloseModal} />
    <HeroCarousel />
    <PopularCategories categories={categories} courses={courses} />
    <HighlightedFeatures />
    {!isSubscribed && (
      <SubscribeSection
        token={token}
        utmSource={utmSource}
        otpStatus={otpStatus}
        loader={loader}
        error={error}
        webOtp={webOtp}
        phNumber={phNumber}
        onSubscribe={onSubscribe}
        onVerifyOtp={onVerifyOtp}
        setUserPackage={setUserPackage}
        setLoader={setLoader}
        setIsActive={setIsActive}
      />
    )}
    <EducationalFeatures />
    <MostViewedVideos videos={mostViewedVideos} onSelect={onMostViewedClick} />
  </>
);

export default Home;
